import { JSX } from 'react';
import { Switch, Route } from 'react-router-dom';
import AccountBillingPage from './AccountBillingPage';

export default function Routes(): JSX.Element {
  return (
    <Switch>
      <Route exact path="/account-and-billing">
        <AccountBillingPage />
      </Route>
    </Switch>
  );
}
